<template>
  <div class="to-top" @click.stop="toTop" v-scroll="showToTop">
    <span class="icon to-top-icon is-medium">
      <i class="fas fa-arrow-alt-circle-up fa-2x" />
    </span>
  </div>
</template>
<script>
export default {
  name: 'ToTop',
  data() {
    return {}
  },
  methods: {
    showToTop(evt, el) {
      if (window.scrollY > 100) {
        el.setAttribute('style', 'transform: translateX(0);')
      } else {
        el.setAttribute('style', 'transform: translateX(-10em);')
      }
    },
    toTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_colors.scss';
.to-top {
  position: fixed;
  top: 92vh;
  left: 1.5em;
  cursor: pointer;
  transform: translateX(-10em);
  transition: all 0.3s ease-in-out;
  & > .to-top-icon {
    border: 1px solid white;
    border-radius: 50%;
    padding: 0;
    background-color: white;
    color: $primary;
    transition: all 0.3s ease-in-out;
  }
  &:hover .to-top-icon {
    border-color: $primary;
    background-color: $primary;
    color: white;
  }
}
</style>
